// export let baseUrl = "http://127.0.0.1:8000";
// export let chatBaseUrl = "http://127.0.0.1:8000";
// export let chatPortUrl = "ws://127.0.0.1::8000/ws/";
export let baseUrl = "https://mrwedsmrs.in";
export let chatBaseUrl = "https://www.mrwedsmrs.com/chat";
export let chatPortUrl = "wss://www.mrwedsmrs.com/chat/ws/";
export let aiChatPortUrl = "https://www.mrwedsmrs.com/ai/predict";

export const Api = {
    register: `${baseUrl}/register/`,
    registerAsPartner: `${baseUrl}/partner_register/`,
    resetPasswordURL: `${baseUrl}/api/change-password/`,
    login: `${baseUrl}/login/`,
    forgetPassword: `${baseUrl}/forget-password/`,
    religions: `${baseUrl}/religions/`,
    community: (id) => `${baseUrl}/community/${id}/religions/`,
    familyNames: (id) => `${baseUrl}/api/family-names/${id}/`,
    profile: (id) => `${baseUrl}/profiles/${id}/`,
    profilePost: `${baseUrl}/profiles/`,
    user: (id) => `${baseUrl}/api/user/${id}/`,
    profileImage: `${baseUrl}/profiles_picture/`,
    getProfile: (id) => `${baseUrl}/profiles_picture/${id}`,
    getLikedUser: (quary) => `${baseUrl}/liked-users/${quary}`,
    getSuccessStoriesAPI: `${baseUrl}/api/success-stories/`,
    allProfile: (quary) => `${baseUrl}/profiles/${quary}`,
    searchProfile: (quary) => `${baseUrl}/search/${quary}`,
    searchCustomProfile: (quary) => `${baseUrl}/api/custom_user/search_by_custom_id/${quary}`,
    userPicturesReq: (id) => `${baseUrl}/api/user-images/${id}/`,
    sendFriendRequest: `${baseUrl}/like/`,
    allNotification: (quary) => `${baseUrl}/user-likerequest/${quary}`,
    acceptFriendReq: (id) => `${baseUrl}/userlikes/${id}/`,
    friendList: (id) => `${baseUrl}/liked-users-likes/${id}/`,
    createChatRoom: `${chatBaseUrl}/rooms/`,
    profilePictureUpdate: (id) => `${baseUrl}/profiles_picture/${id}/`,
    profileDataUpdate: (id) => `${baseUrl}/api/user/${id}/update/`,
    advanceSearch: (quary) => `${baseUrl}/api/profile/advanced/search/${quary}`,
    stripePaymentAPI: `${baseUrl}/stripe/payment/`,
    getSubscriptionAPI: `${baseUrl}/api/subscriptions/`,
    getContactAPI: `${baseUrl}/api/contact-details/`,
    getUserImagesAPI: (id) => `${baseUrl}/api/user-images/${id}/`,
    feedbackAPI: `${baseUrl}/api/contacts/`,
    uploadImageAPI: `${baseUrl}/uploaded_images/`,
    getUserPrefernceAPI: (quary) => `${baseUrl}/api/preferences/${quary}`,
    addUserPrefernceAPI: `${baseUrl}/preferences/`,
    deletePicturesReq: (user_id, pic_id) => `${baseUrl}/delete-image/${user_id}/${pic_id}/`,
    verfyDocumentAPI: `${baseUrl}/documents/`,
    AIMessageAPI: `${aiChatPortUrl}`,
    priceAndLocation: (id) => `${baseUrl}/check_partner_info/${id}/`,
    partnerService: (id) => `${baseUrl}/partner_service/${id}/`,
    getBookingUser: (id) => `${baseUrl}/check_booking_user/${id}/`,
    confirmBooking: `${baseUrl}/accept_confirm/`,
    rejectBooking: `${baseUrl}/reject_confirm/`,
    getBookingInformation: (selectedServiceType, locationValue) => `${baseUrl}/ALL_partner_service/?service_type=${selectedServiceType}&location=${locationValue}`,
    checkUserIsFree: (id,date,check) => `${baseUrl}/booked-services/filter_by_user_and_date/?partner_user_id=${id}&booking_date=${date}&check_data=${check}`,
    bookService: `${baseUrl}/booked-services/`,
    leaveDay: (id) => `${baseUrl}/leave_day/${id}/`,
    aboutUs: `${baseUrl}/api/flatpage//about-us//`,
    PrivacyPolicy: `${baseUrl}/api/flatpage//privacy-policy//`,
    TermConditions: `${baseUrl}/api/flatpage//term-conditions//`,
    CurrentUserCast: (id) =>  `${baseUrl}/api/current-user-cast/${id}/`,
    Disclaimer: `${baseUrl}/api/flatpage//disclaimer//`,
    couponApplyAPI: `${baseUrl}/api/apply-coupon/`,
    paymentURLAPI: `${baseUrl}/api/make-payment/`,


}